import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companyMenuApiClient } from '@src/api/company/menu/companyMenuApiClient';
import Footer from '@src/ui/templates/Company/Footer/Footer';
import MobileHeader from '@src/ui/templates/Company/MobileHeader/MobileHeader';
import CompanyMenubar from '@src/ui/templates/Company/Navbar/CompanyMenubar';
import { NavItem } from '@src/ui/templates/Company/NavMenu/types';
import React, { useEffect, useState } from 'react';

type Props = {
  children: React.ReactNode;
  showCommonComponents?: boolean;
};

function CompanyCenterCardLayout({ children, showCommonComponents = false }: Props) {
  // TODO: ナビゲーションを取得する処理は他のレイアウトでも出現するので共通化する
  const [navItems, setNavItems] = useState<NavItem[]>([]);
  const [showFooter, setShowFooter] = useState(false);
  const fetchCompanyMenu = async () => {
    if (!showCommonComponents) {
      return [];
    }

    const res = await companyMenuApiClient.index();
    handleApiResponse(
      res,
      (data) => {
        const navItems = data.map((menu) => {
          return {
            title: menu.title,
            link: menu.link || '/',
            adminOnly: menu.adminOnly,
            isComingSoon: menu.isComingSoon,
            isLocked: menu.isLocked,
            current: location.pathname === menu.link,
          };
        });
        setNavItems(navItems);
        setShowFooter(true);
      },
      (error) => {
        console.error('メニューの取得に失敗しました:', error);
      },
    );
  };
  useEffect(() => {
    fetchCompanyMenu();
  }, []);

  return (
    <main className='flex min-h-screen flex-col bg-[#F9F9F9] md:bg-white'>
      {showCommonComponents && navItems.length > 0 && (
        <>
          {/* モバイルヘッダー */}
          <div className='lg:block'>
            <MobileHeader navItems={navItems} />
          </div>
          <CompanyMenubar navItems={navItems} />
        </>
      )}
      <div
        className={`grid w-full grow place-items-center py-10 md:flex md:flex-col md:p-0
          ${showCommonComponents ? 'lg:pt-[100px] md:pt-[100px]' : ''}
        `}
      >
        <div
          className={`w-full max-w-[480px] rounded bg-white p-10 md:max-w-full md:px-10 sm:px-5
            ${showCommonComponents ? 'md:pt-0' : 'md:py-20'}
          `}
        >
          {children}
        </div>
      </div>
      {showCommonComponents && showFooter && <Footer />}
    </main>
  );
}

export default CompanyCenterCardLayout;
